interface TextProps {
    text: string
    className?: string
}
export const Text = ({ text, className }: TextProps): JSX.Element => {
    return (
        <p
            className={`text-base text-black ${className}`}
            dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, '<br>') }}
        />
    )
}
